// removed by extract-text-webpack-plugin
module.exports = {"shape":"_1AEBUfVynRzyyCfK0GGZ2u","gradient_00":"_2jKOgnw2BGjNSIG2QQxKwK","gradient_01":"bZOFblGcp_HuBRnNxfVY","gradient_02":"_-7Wk-nBCc4MJPWzx0wNYd","gradient_03":"_1qJSKXTUHQTH2UFKABE6gu","gradient_04":"_3HSX3l6-Mr9aM5yokkM2vu","gradient_05":"_13JP-dU_l89Ey9xBZV6CT","gradient_06":"_2H0yhOzs4sW3zngRxFTd7u","gradient_07":"_2PPBuiCp6MvsPcfqtr2otM","gradient_08":"_2XTuTrYB-J-t5VdtKPLelA","gradient_09":"_1Y9iaiYhKQU7VMPOISE8W4","gradient_10":"_3LwN3rAZkdoipTLks89_5U","gradient_99":"DVDFmPV_iclbUxihcV12s","gray":"_1kMq1YdHsOTbrLHAVA5dAM"};


//////////////////
// WEBPACK FOOTER
// ./src/elements/shape/shape.scss
// module id = 428
// module chunks = 0